module.exports = __webpack_public_path__ + "06_bob_brown.c2f98736.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/06_bob_brown.png
// module id = MKSc
// module chunks = 0